<div ktOffcanvas [options]="offcanvasOptions" id="failure_mode_info_panel" class="kt-quick-panel chatbot-quick-panel"
    [ngStyle]="{ bottom: 'unset'}" #ktOffCanvasRef="ktOffcanvas">
    <kt-chatbot-ui *ngIf="!mobileView" [sidebarUI]="'true'" [mobileView]="mobileView" (closeCanvas)="close()"></kt-chatbot-ui>
</div>
<div class="chatbot-button-container">
    <button class="chatbot-button" (click)="toggleChatbox()"><mat-icon>forum</mat-icon></button>
</div>